import {
	Button,
	Card,
	Col,
	Form,
	Input,
	Row,
	Table,
	Typography
} from "antd";

import React, { Fragment, useEffect, useState } from "react";
import { CSVLink } from "react-csv";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { createDayPartSchedule, getDayPartSchedules } from "../../redux/rtk/features/dayPartSchedule/dayPartSlice";
import ViewBtn from "../Buttons/ViewBtn";
import UserPrivateComponent from "../PrivateRoutes/UserPrivateComponent";
import ColVisibilityDropdown from "../Shared/ColVisibilityDropdown";
import { CsvLinkBtn } from "../UI/CsvLinkBtn";

function CustomTable({ list, loading }) {
	const [columnsToShow, setColumnsToShow] = useState([]);

	const columns = [
		{
			id: 1,
			title: "S.No",
			dataIndex: "serial",
			key: "serial",
		},
		{
			id: 2,
			title: "Full Day Hours",
			dataIndex: "fullDayHours",
			key: "fullDayHours",
		},
		{
			id: 3,
			title: "Half Day Hours",
			dataIndex: "halfDayHours",
			key: "halfDayHours",
		},
		{
			id: 4,
			title: "Action",
			dataIndex: "id",
			key: "action",
			render: (id) => <ViewBtn path={`/admin/dayPartSchedule/${id}/`} />,
		},
	];

	useEffect(() => {
		setColumnsToShow(columns);
	}, []);

	const columnsToShowHandler = (val) => {
		setColumnsToShow(val);
	};

	const addKeys = (arr) => arr.map((i, index) => ({ ...i, key: i.id, serial: index + 1 }));

	return (
		<Card>
			<div className='text-center my-2 flex justify-between'>
				<h5 className='department-list-title text-color-2 text-xl mb-2'>
					Day Part Schedule List
				</h5>
				{list && (
					<div>
						<Button type="primary" className="download-csv-btn">
							<CSVLink
								data={list}
								filename='Day-Part-Schedule'>
								Download CSV
							</CSVLink>
						</Button>
					</div>
				)}
			</div>

			{list && (
				<div style={{ marginBottom: "30px" }}>
					<ColVisibilityDropdown
						options={columns}
						columns={columns}
						columnsToShowHandler={columnsToShowHandler}
					/>
				</div>
			)}

			<Table
				scroll={{ x: true }}
				loading={!list || loading}
				columns={columnsToShow}
				dataSource={list ? addKeys(list) : []}
				pagination={{ position: ['bottomCenter'] }}
			/>
		</Card>
	);
}

const DayPartSchedule = ({ drawer }) => {
	const { list, loading } = useSelector((state) => state.dayPart);
	const [loader, setLoader] = useState(false);
	const [form] = Form.useForm();
	const dispatch = useDispatch();

	useEffect(() => {
		dispatch(getDayPartSchedules());
	}, []);

	const onFinish = async (values) => {
		setLoader(true);
		
		// Convert fullDayHours and halfDayHours to Float
		const formattedValues = {
			...values,
			fullDayHours: parseFloat(values.fullDayHours),
			halfDayHours: parseFloat(values.halfDayHours),
		};
	
		const resp = await dispatch(createDayPartSchedule(formattedValues));
	
		if (resp.payload.message === "success") {
			setLoader(false);
			form.resetFields();
			dispatch(getDayPartSchedules());
		} else {
			setLoader(false);
		}
	};
	
	const onFinishFailed = (errorInfo) => {
		toast.warning("Failed at adding department");
		setLoader(false);
	};

	return (
		<div className="container mx-auto">
			<Row gutter={[16, 16]}>
				<Col xs={24} sm={24} md={10} lg={10} xl={10}>
					<Card bordered={true} className="h-full">
						<UserPrivateComponent permission={"create-publicHoliday"}>
							<div className="text-center mb-4">
								<Typography.Title level={4}>
									Add Day Part Schedule
								</Typography.Title>
							</div>
							<Form
								form={form}
								name="dayPartScheduleForm"
								layout="vertical"
								onFinish={onFinish}
								onFinishFailed={onFinishFailed}
								autoComplete="off"
							>
								<Form.Item
									label={<span className="required-label">Full Day Hours:</span>}
									name="fullDayHours"
									rules={[
										{
											required: true,
											message: "Please input Full Day Hours!",
										},
									]}
								>
									<Input placeholder="Full Day Hours" />
								</Form.Item>

								<Form.Item
									label={<span className="required-label">Half Day Hours:</span>}
									name="halfDayHours"
									rules={[
										{
											required: true,
											message: "Please input Half Day Hours!",
										},
									]}
								>
									<Input placeholder="Half Day Hours" />
								</Form.Item>
								
								<Form.Item>
									<Button
										type="primary"
										size="large"
										htmlType="submit"
										block
										loading={loader}
									>
										Add
									</Button>
								</Form.Item>
							</Form>
						</UserPrivateComponent>
					</Card>
				</Col>
				
				<Col xs={24} sm={24} md={14} lg={14} xl={14}>
					<UserPrivateComponent permission={"readAll-publicHoliday"}>
						<CustomTable list={list} loading={loading} />
					</UserPrivateComponent>
				</Col>
			</Row>
		</div>
	);
};

export default DayPartSchedule;